export const environment = {
  production: false,
  leafletApiKey: 'a9cae192-8738-472d-8309-5f7f7bc6e47f',
  endpoints: {
    restApi: 'https://api.viatracks.com/api',
    viaTracksHub: 'https://viatracks-push.devinco.com/viatracksHub',
  },
  auth: { clientSecret: '#{ViaTracks.Route.Code}#' },
  notificationDisplayTime: 2000,
};
